import axios from "axios";
import {
    GET_ALL_ARTICLES,
    GET_ALL_ARTICLES_UPDATED,
    GET_ALL_ARTICLES_PAGE,
    GET_ALL_ARTICLES_TAG,
    ALL_ARTICLES_ERROR,
    GET_ARTICLE,
    GET_ARTICLE_ERROR,
    GET_RESEARCH_ARTICLES_PAGINATED,
    GET_RESEARCH_ARTICLES_PAGINATED_ERROR,
    GET_FEATURED_ARTICLES,
    GET_FEATURED_ARTICLES_ERROR,
    GET_CASE_STUDIES_COUNT,
    GET_MARKETING_COUNT,
    SET_FEATURED_ARTICLE,
    GET_ALL_PODCASTS,
    GET_PODCASTS,
    GET_PODCAST_COUNT,
    ADD_PODCAST,
    UPDATE_PODCAST,
    DELETE_PODCAST,
    GET_CE,
    GET_CE_COUNT,
    GET_OTHER,
    GET_OTHER_COUNT,
    GET_INFORMATION,
    GET_INFORMATION_COUNT,
    SELECT_ARTICLE,
    SEARCH_CASE_STUDIES_PAGINATED,
    SEARCH_MARKETING_PAGE,
    SEARCH_PODCAST_PAGE,
    SEARCH_CE_PAGE,
    SEARCH_OTHER_PAGE,
    SEARCH_INFORMATION_PAGE,
    SET_FEATURED_ARTICLE_ERROR,
    SET_FEATURED_ARTICLES_FALSE,
    SET_FEATURED_ARTICLES_FALSE_ERROR,
    GET_ARTICLE_COUNT,
    GET_ARTICLE_COUNT_ERROR,
    ADD_ARTICLE,
    ADD_ARTICLE_ERROR,
    UPDATE_ARTICLE,
    UPDATE_ARTICLE_TAG,
    DELETE_ARTICLE,
    UPDATE_ARTICLE_ERROR,
    DELETE_ARTICLE_ERROR,
    GET_ALL_ARTICLES_PAGE_ERROR,
    GET_CASE_STUDY_ARTICLES_PAGINATED,
    GET_CASE_STUDY_ARTICLES_PAGINATED_ERROR,
    GET_MARKETING_MATERIALS_ARTICLES_PAGINATED,
    GET_MARKETING_MATERIALS_ARTICLES_PAGINATED_ERROR,
    SEARCH_CASE_STUDIES_PAGINATED_ERROR,
    SEARCH_MARKETING_PAGE_ERROR,
    GET_CASE_STUDIES_COUNT_ERROR,
    GET_MARKETING_COUNT_ERROR,
    GET_FEATURED_EBOOKS,
    SET_FEATURED_EBOOK,
    SET_FEATURED_EBOOKS_FALSE,
    GET_FEATURED_EBOOKS_ERROR,
    SET_FEATURED_EBOOK_ERROR,
    SET_FEATURED_EBOOKS_FALSE_ERROR,
    GET_ALL_PODCASTS_ERROR,
    GET_PODCASTS_ERROR,
    GET_PODCAST_COUNT_ERROR,
    ADD_PODCAST_ERROR,
    UPDATE_PODCAST_ERROR,
    DELETE_PODCAST_ERROR,
    SEARCH_PODCAST_PAGE_ERROR,
    GET_CE_ERROR,
    GET_CE_COUNT_ERROR,
    SEARCH_CE_PAGE_ERROR,
    GET_INFORMATION_ERROR,
    GET_INFORMATION_COUNT_ERROR,
    SEARCH_INFORMATION_PAGE_ERROR,
    GET_OTHER_ERROR,
    GET_OTHER_COUNT_ERROR,
    SEARCH_OTHER_PAGE_ERROR,
    GET_ARTICLE_PRODUCTS,
    GET_ARTICLE_PRODUCTS_ERROR,
    UPDATE_ARTICLE_PRODUCT_MAP,
    UPDATE_ARTICLE_PRODUCT_MAP_ERROR,
    DELETE_ARTICLE_PRODUCT_ASSOCIATION,
    DELETE_ARTICLE_PRODUCT_ASSOCIATION_ERROR,
    GET_EBOOKS,
    GET_EBOOKS_ERROR,
    SEARCH_ALL_ARTICLES_PAGE,
    SEARCH_ALL_ARTICLES_PAGE_ERROR,
    UNPUBLISH_ARTICLES,
    UNPUBLISH_ARTICLES_ERROR,
    GET_ALL_FEATURED_RECENT_ARTICLES,
    GET_FEATURED_RECENT_ARTICLES_BY_CATEGORY,
    DELETE_FEATURED_RECENT_ARTICLES,
    ADD_FEATURED_RECENT_ARTICLE,
    GET_ALL_FEATURED_RECENT_ARTICLES_ERROR,
    GET_FEATURED_RECENT_ARTICLES_BY_CATEGORY_ERROR,
    DELETE_FEATURED_RECENT_ARTICLES_ERROR,
    ADD_FEATURED_RECENT_ARTICLE_ERROR,
    GET_ALL_URL_TITLES,
    SEARCH_PUBLISHED_ARTICLES,
    SEARCH_PUBLISHED_ARTICLES_ERROR,
    SET_CASE_STUDY_LIST_IS_LOADING_TRUE,
    SEARCH_CASE_STUDIES_COUNT,
    SEARCH_CASE_STUDIES_COUNT_ERROR,
    SET_RESEARCH_LIST_IS_LOADING_TRUE,
    GET_RESEARCH_ARTICLES_COUNT,
    GET_RESEARCH_ARTICLES_COUNT_ERROR,
    SEARCH_RESEARCH_ARTICLES_PAGINATED,
    SEARCH_RESEARCH_ARTICLES_PAGINATED_ERROR,
    SEARCH_RESEARCH_ARTICLES_COUNT,
    SEARCH_RESEARCH_ARTICLES_COUNT_ERROR,
    SET_MARKETING_MATERIALS_LIST_IS_LOADING_TRUE,
    GET_MARKETING_MATERIALS_SEARCH_COUNT,
    GET_MARKETING_MATERIALS_SEARCH_COUNT_ERROR,
    SET_PODCAST_LIST_IS_LOADING_TRUE,
    GET_PODCAST_SEARCH_COUNT,
    GET_PODCAST_SEARCH_COUNT_ERROR,
    SET_CE_LIST_IS_LOADING_TRUE,
    SEARCH_CE_COUNT,
    SEARCH_CE_COUNT_ERROR,
    SET_INFO_ARTICLES_LIST_IS_LOADING_TRUE,
    GET_INFO_ARTICLES_SEARCH_COUNT,
    GET_INFO_ARTICLES_SEARCH_COUNT_ERROR,
    SET_OTHER_ARTICLES_LIST_IS_LOADING_TRUE,
    GET_OTHER_ARTICLES_SEARCH_COUNT,
    GET_OTHER_ARTICLES_SEARCH_COUNT_ERROR,
    GET_CASE_STUDIES_MANUFACTURERS,
    GET_CASE_STUDIES_MANUFACTURERS_ERROR,


    SET_ARTICLES_LIST_IS_LOADING_TRUE,
    GET_ARTICLES_MANUFACTURERS_FOR_FILTERS,
    GET_ARTICLES_MANUFACTURERS_FOR_FILTERS_ERROR,
    GET_ALL_ARTICLES_PAGINATED_BY_TYPE,
    GET_ALL_ARTICLES_PAGINATED_BY_TYPE_ERROR,
    GET_ALL_ARTICLES_COUNT_BY_TYPE,
    GET_ALL_ARTICLES_COUNT_BY_TYPE_ERROR,
    SEARCH_ARTICLES_PAGINATED_BY_TYPE,
    SEARCH_ARTICLES_PAGINATED_BY_TYPE_ERROR,
    SEARCH_ARTICLES_COUNT_BY_TYPE,
    SEARCH_ARTICLES_COUNT_BY_TYPE_ERROR,
    REMOVE_HOME_PAGE_FEATURED_EBOOK,
    REMOVE_HOME_PAGE_FEATURED_EBOOK_ERROR,
 
} from "./types";
import { setAlert } from "./alerts";
import { selectArticleForTemplate } from "./articleTemplates";

const baseUrl = process.env.REACT_APP_BASE_URL;


////////////////////////////////////////////////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////////////////////////////////////////////
///////// NEW STAND ALONE DPS CMS ACTIONS ////////////////////////////////////////////////////////// 
////////////////////////////////////////////////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////////////////////////////////////////////



////////////////////////////////////////////////////////////////////////////////////////////////////
///////// SHARED ARTICLE ACTIONS FOR ALL ARTICLE TYPES /////////////////////////////////////////////
////////////////////////////////////////////////////////////////////////////////////////////////////
// SET ISLOADING ARTICLES LIST TO TRUE BEFORE CALLING THE API
// SET ISLOADING ARTICLES LIST TO TRUE BEFORE CALLING THE API
// SET ISLOADING ARTICLES LIST TO TRUE BEFORE CALLING THE API
export const setArticlesListTrue = () => (dispatch) => {
    dispatch({
        type: SET_ARTICLES_LIST_IS_LOADING_TRUE,
    });
};
// GET ALL ARTICLES MANUFACTURERS FOR MANUFACTURER FILTER ON LIST PAGE 
// GET ALL ARTICLES MANUFACTURERS FOR MANUFACTURER FILTER ON LIST PAGE 
// GET ALL ARTICLES MANUFACTURERS FOR MANUFACTURER FILTER ON LIST PAGE 
export const getArticleManufacturers = (articleType) => async (dispatch) => {
    try {
        const response = await axios.get(
            `${baseUrl}/api/articles/getArticleTypeManufacturers/${articleType}`
        );
        dispatch({
            type: GET_ARTICLES_MANUFACTURERS_FOR_FILTERS,
            payload: response.data,
        });
    } catch (err) {
        dispatch({
            type: GET_ARTICLES_MANUFACTURERS_FOR_FILTERS_ERROR,
            payload: [],
        });
    }
};
// GET ALL ARTICLES PAGINATED BY "articletype" WITH FILTERS 
// GET ALL ARTICLES PAGINATED BY "articletype" WITH FILTERS 
// GET ALL ARTICLES PAGINATED BY "articletype" WITH FILTERS 
export const getAllArticlesPaginatedByType = (page, articleType, newestFilter, manufacturerFilter, pagesize = 10) => async (dispatch) => {
    try {
        dispatch(setArticlesListTrue());
        
        const response = await axios.get(`${baseUrl}/api/articles/getAllArticlesPaginatedByType/${page}/${articleType}/${newestFilter}/${manufacturerFilter}/${pagesize}`);

        dispatch({
            type: GET_ALL_ARTICLES_PAGINATED_BY_TYPE,
            payload: response.data,
        });
    } catch (err) {
        dispatch({
            type: GET_ALL_ARTICLES_PAGINATED_BY_TYPE_ERROR,
            payload: { msg: `Could not fetch paginated articles - article type: ${articleType}, manufacturerFilter: ${manufacturerFilter}, pagination page: ${page}` },
        });
    }
};
// GET ALL ARTICLES PAGINATED BY "articletype" COUNT  
// GET ALL ARTICLES PAGINATED BY "articletype" COUNT  
// GET ALL ARTICLES PAGINATED BY "articletype" COUNT  
export const getAllArticlesCountByType = (articleType, manufacturerFilter) => async (dispatch) => {
    try {
        const response = await axios.get(`${baseUrl}/api/articles/getAllArticlesCountByType/${articleType}/${manufacturerFilter}`);

        dispatch({
            type: GET_ALL_ARTICLES_COUNT_BY_TYPE,
            payload: response.data,
        });
    } catch (err) {
        dispatch({
            type: GET_ALL_ARTICLES_COUNT_BY_TYPE_ERROR,
            payload: { msg: `Could not fetch count of all articles - article type: ${articleType}, manufacturerFilter: ${manufacturerFilter}` },
        });
    }
};
// GET (SEARCH) ARTICLES PAGINATED by "articleType" WITH FILTERS
// GET (SEARCH) ARTICLES PAGINATED by "articleType" WITH FILTERS
// GET (SEARCH) ARTICLES PAGINATED by "articleType" WITH FILTERS
export const getSearcArticlesPaginatedByType = (page, articleType, searchString, newestFilter, manufacturerFilter, pageSize = 10) => async (dispatch) => {
    try {
        dispatch(setArticlesListTrue());
        
        const response = await axios.get(
            `${baseUrl}/api/articles/getSearcArticlesPaginatedByType/${page}/${articleType}/${searchString}/${newestFilter}/${manufacturerFilter}/${pageSize}`
        );
        dispatch({
            type: SEARCH_ARTICLES_PAGINATED_BY_TYPE,
            payload: response.data,
        });
    } catch (err) {
        dispatch({
            type: SEARCH_ARTICLES_PAGINATED_BY_TYPE_ERROR,
            payload: [],
        });
    }
};
// GET COUNT OF (SEARCH) ALL ARTICLES PAGINATED BY "articletype" WITH FILTERS
// GET COUNT OF (SEARCH) ALL ARTICLES PAGINATED BY "articletype" WITH FILTERS
// GET COUNT OF (SEARCH) ALL ARTICLES PAGINATED BY "articletype" WITH FILTERS
export const getSearchArticlesCountByType = (articleType, searchString, manufacturerFilter) => async (dispatch) => {
    try {
        const response = await axios.get(
            `${baseUrl}/api/articles/searchArticlesCountByType/${articleType}/${searchString}/${manufacturerFilter}`
        );
        dispatch({
            type: SEARCH_ARTICLES_COUNT_BY_TYPE,
            payload: response.data,
        });
    } catch (err) {
        dispatch({
            type: SEARCH_ARTICLES_COUNT_BY_TYPE_ERROR,
            payload: [],
        });
    }
};





////////////////////////////////////////////////////////////////////////////////////////////////////
///////// PODCASTS ACTIONS ///////////////////////////////////////////////////
////////////////////////////////////////////////////////////////////////////////////////////////////
// NOTE THESE PODCASTS ACTIONS ARE IN ARTICLE REDUX ACTIONS FILE BECAUSE THE ROUTES ON SERVER WERE FOUND IN ARTICLES.JS ROUTE FILE

// SET ISLOADING PODCASTS LIST TO TRUE BEFORE CALLING THE API
// SET ISLOADING PODCASTS LIST TO TRUE BEFORE CALLING THE API
// SET ISLOADING PODCASTS LIST TO TRUE BEFORE CALLING THE API
export const setLoadingPodcastsListTrue = () => (dispatch) => {
    dispatch({
        type: SET_PODCAST_LIST_IS_LOADING_TRUE,
    });
};
// GET PODCASTS PAGINATED WITH FILTERS 
// GET PODCASTS PAGINATED WITH FILTERS 
// GET PODCASTS PAGINATED WITH FILTERS 
export const getPodcastsPaginated = (page, newestFilter, pagesize) => async (dispatch) => {
    try {
        dispatch(setLoadingPodcastsListTrue());
        const response = await axios.get(
            `${baseUrl}/api/articles/new/getPodcastsPaginated/${page}/${newestFilter}/${pagesize}`
        );
        dispatch({
            type: GET_PODCASTS,
            payload: response.data,
        });
    } catch (err) {
        dispatch({
            type: GET_PODCASTS_ERROR,
            payload: { msg: "Could not fetch all podcasts" },
        });
    }
};
// GET PODCASTS COUNT  
// GET PODCASTS COUNT  
// GET PODCASTS COUNT
export const getPodcastCount = () => async (dispatch) => {
    try {
        const response = await axios.get(`${baseUrl}/api/articles/new/getPodcastCount`);

        dispatch({
            type: GET_PODCAST_COUNT,
            payload: response.data,
        });
    } catch (err) {
        dispatch({
            type: GET_PODCAST_COUNT_ERROR,
            payload: { msg: "Could not fetch the podcast count" },
        });
    }
};
// GET (SEARCH) PODCASTS PAGINATED WITH FILTERS
// GET (SEARCH) PODCASTS PAGINATED WITH FILTERS
// GET (SEARCH) PODCASTS PAGINATED WITH FILTERS
export const searchPodcastsPaginated = (page, searchString, newestFilter, pageSize) => async (dispatch) => {
    try {
        const response = await axios.get(
            `${baseUrl}/api/articles/new/searchPodcastsPaginated/${page}/${searchString}/${newestFilter}/${pageSize}`
        );
        dispatch({
            type: SEARCH_PODCAST_PAGE,
            payload: response.data,
        });
    } catch (err) {
        dispatch({
            type: SEARCH_PODCAST_PAGE_ERROR,
            payload: [],
        });
    }
};
// GET COUNT OF (SEARCH) PODCASTS 
// GET COUNT OF (SEARCH) PODCASTS 
// GET COUNT OF (SEARCH) PODCASTS 
export const getPodcastSearchCount = (searchString) => async (dispatch) => {
    try {
        const response = await axios.get(`${baseUrl}/api/articles/new/getPodcastSearchCount/${searchString}`);

        dispatch({
            type: GET_PODCAST_SEARCH_COUNT,
            payload: response.data,
        });
    } catch (err) {
        dispatch({
            type: GET_PODCAST_SEARCH_COUNT_ERROR,
            payload: { msg: "Could not fetch the podcast search count" },
        });
    }
};



////////////////////////////////////////////////////////////////////////////////////////////////////
///////// HOME PAGE FEATURED EBOOKS ACTIONS ///////////////////////////////////////////////////
////////////////////////////////////////////////////////////////////////////////////////////////////

// PUT - REMOVES ALL (HOME PAGE) FEATURED EBOOKS
// PUT - REMOVES ALL (HOME PAGE) FEATURED EBOOKS
// PUT - REMOVES ALL (HOME PAGE) FEATURED EBOOKS
export const setFeaturedEbooksFalse = () => async (dispatch) => {
    try {
        const response = await axios.put(
            `${baseUrl}/api/articles/set-featured-ebook-false`
        );

        dispatch({
            type: SET_FEATURED_EBOOKS_FALSE,
            payload: response.data,
        });
        // dispatch(getFeaturedEbooks());
    } catch (err) {
        dispatch({
            type: SET_FEATURED_EBOOKS_FALSE_ERROR,
            payload: { msg: "Could not remove ebooks as featured" },
        });
    }
};


// PUT - UPDATES / ADDS (HOME PAGE) FEATURED EBOOK
// PUT - UPDATES / ADDS (HOME PAGE) FEATURED EBOOK
// PUT - UPDATES / ADDS (HOME PAGE) FEATURED EBOOK
export const setFeaturedEbook = (id, featuredEbook, isLast) => async (dispatch) => {
    try {
        const response = await axios.put(
            `${baseUrl}/api/articles/set-featured-ebook/${id}`,
            {
                featuredEbook,
            }
        );

        dispatch({
            type: SET_FEATURED_EBOOK,
            payload: response.data,
        });
       
        if (isLast) {
            dispatch(setAlert("Ebook added as featured succesfully!", "success"));
            dispatch(getFeaturedEbooks());
        }
    } catch (err) {
        dispatch(setAlert("Could not set ebook as featured", "danger"));
        dispatch({
            type: SET_FEATURED_EBOOK_ERROR,
            payload: { msg: "Could not set ebook as featured" },
        });
    }
};

// GET - ALL HOMEPAGE FEATURED EBOOKS
// GET - ALL HOMEPAGE FEATURED EBOOKS
// GET - ALL HOMEPAGE FEATURED EBOOKS
export const getFeaturedEbooks = () => async (dispatch) => {
    try {
        const response = await axios.get(`${baseUrl}/api/articles/featured-ebook`);

        dispatch({
            type: GET_FEATURED_EBOOKS,
            payload: response.data,
        });
    } catch (err) {
        dispatch({
            type: GET_FEATURED_EBOOKS_ERROR,
            payload: { msg: "Could not fetch all featured ebooks" },
        });
    }
};
// PUT - REMOVES (HOME PAGE) FEATURED EBOOK BY ID
// PUT - REMOVES (HOME PAGE) FEATURED EBOOK BY ID
// PUT - REMOVES (HOME PAGE) FEATURED EBOOK BY ID
// (CALLED at CMS FEATURED CONTENT -> HOME PAGE -> EBOOK -> REMOVE FEATURED EBOOK FORM)
export const removeFeatureEbook = (id) => async (dispatch) => {
    try {
        const response = await axios.put( `${baseUrl}/api/articles/new/removeFeatureEbook/${id}`);
    
        dispatch({
            type: REMOVE_HOME_PAGE_FEATURED_EBOOK,
            payload: response.data,
        });
        dispatch(getFeaturedEbooks());
    } catch (err) {
        dispatch({
            type: REMOVE_HOME_PAGE_FEATURED_EBOOK_ERROR,
            payload: { msg: "Could not remove Ebook as featured" },
        });
    }
};


///// OLD ACTIONS BELOW - HAVE YET TO BE APPLIED FOR NEW STAND ALONE DPS CMS
///// OLD ACTIONS BELOW - HAVE YET TO BE APPLIED FOR NEW STAND ALONE DPS CMS
///// OLD ACTIONS BELOW - HAVE YET TO BE APPLIED FOR NEW STAND ALONE DPS CMS


//gets all articles
export const getArticles = () => async (dispatch) => {
    try {
        const response = await axios.get(`${baseUrl}/api/articles`);

        dispatch({
            type: GET_ALL_ARTICLES,
            payload: response.data,
        });
    } catch (err) {
        dispatch({
            type: ALL_ARTICLES_ERROR,
            payload: { msg: "Could not fetch all articles" },
        });
    }
};

//gets all articles for tag/seos
export const getArticlesTag = () => async (dispatch) => {
    try {
        const response = await axios.get(`${baseUrl}/api/articles/tag`);

        dispatch({
            type: GET_ALL_ARTICLES_TAG,
            payload: response.data,
        });
    } catch (err) {
        dispatch({
            type: ALL_ARTICLES_ERROR,
            payload: { msg: "Could not fetch all articles" },
        });
    }
};

//gets all recently updated manufacturers
export const getArticlesUpdated = () => async (dispatch) => {
    try {
        const response = await axios.get(`${baseUrl}/api/articles/tag/recent`);

        dispatch({
            type: GET_ALL_ARTICLES_UPDATED,
            payload: response.data,
        });
    } catch (err) {
        dispatch({
            type: ALL_ARTICLES_ERROR,
            payload: { msg: "Could not fetch all manufacturers" },
        });
    }
};

//gets the total count of articles
export const getArticleCount = () => async (dispatch) => {
    try {
        const response = await axios.get(`${baseUrl}/api/articles/count`);

        dispatch({
            type: GET_ARTICLE_COUNT,
            payload: response.data,
        });
    } catch (err) {
        dispatch({
            type: GET_ARTICLE_COUNT_ERROR,
            payload: { msg: "Could not fetch the article count" },
        });
    }
};







//delete podcast
export const deletePodcast = (id, podcast, page) => async (dispatch) => {
    try {
        const response = await axios.delete(`${baseUrl}/api/articles/delete-podcast/${id}`);

        dispatch({
            type: DELETE_PODCAST,
            payload: response.data,
        });

        dispatch(getPodcastsPaginated(page));
    } catch (err) {
        dispatch({
            type: DELETE_PODCAST_ERROR,
            payload: { msg: "Could not delete podcast" },
        });
    }
}







//gets all articles paginated
export const getArticlesPage = (page) => async (dispatch) => {
    try {
        const response = await axios.get(`${baseUrl}/api/articles/page/${page}/25`);

        dispatch({
            type: GET_ALL_ARTICLES_PAGE,
            payload: response.data,
        });
    } catch (err) {
        dispatch({
            type: GET_ALL_ARTICLES_PAGE_ERROR,
            payload: { msg: "Could not fetch all articles" },
        });
    }
};

//gets article by id
export const getArticle = (id) => async (dispatch) => {
    try {
        const response = await axios.get(`${baseUrl}/api/articles/article/${id}`);

        dispatch({
            type: GET_ARTICLE,
            payload: response.data,
        });
    } catch (err) {
        dispatch({
            type: GET_ARTICLE_ERROR,
            payload: { msg: "Could not fetch article" },
        });
    }
};

//gets article by id
export const getArticleProducts = (id) => async (dispatch) => {
    try {
        const response = await axios.get(`${baseUrl}/api/articles/article-map/${id}`);

        dispatch({
            type: GET_ARTICLE_PRODUCTS,
            payload: response.data,
        });
    } catch (err) {
        dispatch({
            type: GET_ARTICLE_PRODUCTS_ERROR,
            payload: { msg: "Could not fetch article products" },
        });
    }
};

//Add new article
export const addArticle = (article, productList, takeaways, contributors, pageArticleType, page, searchTerm, newestFilter, manufacturerFilter) => async (dispatch) => {
    try {
        const response = await axios.post(`${baseUrl}/api/articles/`, {
            article,
            productList,
            takeaways,
            contributors
        });
        
        dispatch({
            type: ADD_ARTICLE,
            payload: response.data,
        });

        if (article.is_templated) {
            dispatch(selectArticleForTemplate(response.data))
        }
        else if (searchTerm) {
            dispatch(getSearcArticlesPaginatedByType(page, pageArticleType, searchTerm, newestFilter, manufacturerFilter));
        } else {
            dispatch(getAllArticlesPaginatedByType(page, pageArticleType, newestFilter, manufacturerFilter));
        }
        dispatch(setAlert("Article added successfully!", "success"));
    } catch (err) {
        dispatch(setAlert("Failed to add article", "danger"));
        dispatch({
            type: ADD_ARTICLE_ERROR,
            payload: { msg: "Could not add article" },
        });
    }
};

//update article by id
export const updateArticle = (id, article, takeaways, contributors, pageArticleType, page, searchTerm, newestFilter, manufacturerFilter) => async (dispatch) => {
    try {
        const response = await axios.put(`${baseUrl}/api/articles/article/${id}`, {
            article,
            takeaways,
            contributors
        });

        dispatch({
            type: UPDATE_ARTICLE,
            payload: response.data,
        });
        dispatch(setAlert("Article successfully updated!", "success"));

        if (searchTerm) {
            dispatch(getSearcArticlesPaginatedByType(page, pageArticleType, searchTerm, newestFilter, manufacturerFilter));
        } else {
            dispatch(getAllArticlesPaginatedByType(page, pageArticleType, newestFilter, manufacturerFilter));
        }
    } catch (err) {
        dispatch(setAlert("Unable to update article", "danger"));
        dispatch({
            type: UPDATE_ARTICLE_ERROR,
            payload: { msg: "Could not update article" },
        });
    }
};

export const addArticleProductAssociation = (productList) => async (dispatch) => {
    try {
        const response = await axios.post(`${baseUrl}/api/articles/article-product-map/`, {
            productList
        });

        dispatch({
            type: UPDATE_ARTICLE_PRODUCT_MAP,
            payload: response.data,
        });
        dispatch(setAlert("Article Map successfully updated!", "success"));

    } catch (err) {
        dispatch(setAlert("Unable to update article map", "danger"));
        dispatch({
            type: UPDATE_ARTICLE_PRODUCT_MAP_ERROR,
            payload: { msg: "Could not update article map" },
        });
    }
}

//delete podcast
export const deleteArticleProductAssociation = (id, prodId) => async (dispatch) => {
    try {
        
        const response = await axios.delete(`${baseUrl}/api/articles/article-product-map/${id}/${prodId}`);

        dispatch({
            type: DELETE_ARTICLE_PRODUCT_ASSOCIATION,
            payload: response.data,
        });

    } catch (err) {
        dispatch({
            type: DELETE_ARTICLE_PRODUCT_ASSOCIATION_ERROR,
            payload: { msg: "Could not delete article product association" },
        });
    }
}

//update article tag by id
export const updateArticleTag = (id, article, page) => async (dispatch) => {
    try {
        const response = await axios.put(`${baseUrl}/api/articles/article/${id}`, {
            article,
        });

        dispatch({
            type: UPDATE_ARTICLE_TAG,
            payload: response.data,
        });
        dispatch(setAlert("Article successfully updated!", "success"));
        dispatch(getArticlesUpdated());
    } catch (err) {
        dispatch(setAlert("Unable to update article", "danger"));
        dispatch({
            type: UPDATE_ARTICLE_ERROR,
            payload: { msg: "Could not update article" },
        });
    }
};

//delete product by id
export const deleteArticle = (id, article, page, pageArticleType, searchTerm, newestFilter, manufacturerFilter) => async (dispatch) => {
    try {
        const response = await axios.delete(`${baseUrl}/api/articles/${id}`);

        dispatch({
            type: DELETE_ARTICLE,
            payload: response.data,
        });
        
        if (searchTerm) {
            dispatch(getSearcArticlesPaginatedByType(page, pageArticleType, searchTerm, newestFilter, manufacturerFilter));
        } else {
            dispatch(getAllArticlesPaginatedByType(page, pageArticleType, newestFilter, manufacturerFilter));
        }
        dispatch(setAlert("Article successfully deleted!", "success"));
    } catch (err) {
        dispatch(setAlert("Unable to delete article", "danger"));
        dispatch({
            type: DELETE_ARTICLE_ERROR,
            payload: { msg: "Could not delete article" },
        });
    }
};


//reset ce article date by id
export const resetArticleDate = (id, pageArticleType, page, searchTerm, newestFilter, manufacturerFilter) => async (dispatch) => {
    try {
        const response = await axios.put(`${baseUrl}/api/articles/reset/${id}`);

        dispatch({
            type: UPDATE_ARTICLE,
            payload: response.data,
        });

        if (searchTerm) {
            dispatch(getSearcArticlesPaginatedByType(page, pageArticleType, searchTerm, newestFilter, manufacturerFilter));
        } else {
            dispatch(getAllArticlesPaginatedByType(page, pageArticleType, newestFilter, manufacturerFilter));
        }
        
        dispatch(setAlert("CE article date successfully changed!", "success"));
    } catch (err) {
        dispatch(setAlert("Unable to change CE article date", "danger"));
        dispatch({
            type: UPDATE_ARTICLE_ERROR,
            payload: { msg: "Could not change CE article date" },
        });
    }
};

//add new podcast
export const addPodcast = (podcast, page) => async (dispatch) => {
    try {
        const response = await axios.post(`${baseUrl}/api/articles/add-podcast`, {
            podcast,
        });

        dispatch({
            type: ADD_PODCAST,
            payload: response.data,
        });

        dispatch(getPodcastsPaginated(page));
        dispatch(setAlert("Podcast added successfully!", "success"));
    } catch (err) {
        dispatch(setAlert("Failed to add podcast", "danger"));
        dispatch({
            type: ADD_PODCAST_ERROR,
            payload: { msg: "Could not add podcast" },
        });
    }
}

//update podcast
export const updatePodcast = (id, podcast, page) => async (dispatch) => {
    try {
        const response = await axios.put(`${baseUrl}/api/articles/podcast/${id}`, {
            podcast,
        });

        dispatch({
            type: UPDATE_PODCAST,
            payload: response.data,
        });
        dispatch(setAlert("Podcast successfully updated!", "success"));
        dispatch(getPodcastsPaginated(page));

    } catch (err) {
        dispatch(setAlert("Unable to update podcast", "danger"));
        dispatch({
            type: UPDATE_PODCAST,
            payload: { msg: "Could not update podcast" },
        });
    }
};









//GET gets all podcasts
export const getAllPodcasts = () => async (dispatch) => {
    try {
        const response = await axios.get(
            `${baseUrl}/api/articles/podcasts/`
        );
        dispatch({
            type: GET_ALL_PODCASTS,
            payload: response.data,
        });
    } catch (err) {
        dispatch({
            type: GET_ALL_PODCASTS_ERROR,
            payload: { msg: "Could not fetch all podcasts" },
        });
    }
};







//search case articles with pagination and count
export const searchAllArticlesPage = (article, page) => async (dispatch) => {
    try {
        const response = await axios.get(
            `${baseUrl}/api/articles/search-articles/${article}/${page}/25`
        );
        dispatch({
            type: SEARCH_ALL_ARTICLES_PAGE,
            payload: response.data,
        });
    } catch (err) {
        dispatch({
            type: SEARCH_ALL_ARTICLES_PAGE_ERROR,
            payload: [],
        });
    }
};
// GET - SEARCH PUBLISHED ARTICLES BASED ON SEARCH STRING
// GET - SEARCH PUBLISHED ARTICLES BASED ON SEARCH STRING
// GET - SEARCH PUBLISHED ARTICLES BASED ON SEARCH STRING
export const searchPublishedArticles = (article) => async (dispatch) => {
    try {
        const response = await axios.get(
            `${baseUrl}/api/articles/search-articles-published/${article}`
        );
        dispatch({
            type: SEARCH_PUBLISHED_ARTICLES,
            payload: response.data,
        });
    } catch (err) {
        dispatch({
            type: SEARCH_PUBLISHED_ARTICLES_ERROR,
            payload: [],
        });
    }
};













//gets all featured articles
export const getFeaturedArticles = () => async (dispatch) => {
    try {
        const response = await axios.get(`${baseUrl}/api/articles/featured`);

        dispatch({
            type: GET_FEATURED_ARTICLES,
            payload: response.data,
        });
    } catch (err) {
        dispatch({
            type: GET_FEATURED_ARTICLES_ERROR,
            payload: { msg: "Could not fetch all featured articles" },
        });
    }
};

//set content as featured for homepage
export const setFeaturedArticles = (featuredArticles) => async (dispatch) => {
    try {
        const response = await axios.put(
            `${baseUrl}/api/articles/set-new-featured/`,
            {
                featuredArticles,
            }
        );

        dispatch({
            type: SET_FEATURED_ARTICLE,
            payload: response.data,
        });
        dispatch(setAlert("Article added as featured succesfully!", "success"));
        dispatch(getFeaturedArticles());
    } catch (err) {
        dispatch(setAlert("Could not set article as featured", "danger"));
        dispatch({
            type: SET_FEATURED_ARTICLE_ERROR,
            payload: { msg: "Could not set article as featured" },
        });
    }
};

// export const setFeaturedArticle = (id, featuredArticle) => async (dispatch) => {
//   try {
//     const response = await axios.put(
//       `${baseUrl}/api/articles/set-new-featured/${id}`,
//       {
//         featuredArticle,
//       }
//     );

//     dispatch({
//       type: SET_FEATURED_ARTICLE,
//       payload: response.data,
//     });
//     dispatch(setAlert("Article added as featured succesfully!", "success"));
//     // dispatch(getFeaturedArticles());
//   } catch (err) {
//     dispatch(setAlert("Could not set article as featured", "danger"));
//     dispatch({
//       type: SET_FEATURED_ARTICLE_ERROR,
//       payload: { msg: "Could not set article as featured" },
//     });
//   }
// };

//set all previously featured products as false
export const setFeaturedArticlesFalse = () => async (dispatch) => {
    try {
        const response = await axios.put(
            `${baseUrl}/api/articles/set-featured-false`
        );

        dispatch({
            type: SET_FEATURED_ARTICLES_FALSE,
            payload: response.data,
        });
        dispatch(getFeaturedArticles());
    } catch (err) {
        dispatch({
            type: SET_FEATURED_ARTICLES_FALSE_ERROR,
            payload: { msg: "Could not remove articles as featured" },
        });
    }
};

//set published articles to false
export const unpublishArticles = (articleIdArray) => async (dispatch) => {
    try {
        const response = await axios.put(
            `${baseUrl}/api/articles/bulkunpublish`, { articleIdArray }
        );

        dispatch({
            type: UNPUBLISH_ARTICLES,
            payload: response.data,
        });
    } catch (err) {
        dispatch({
            type: UNPUBLISH_ARTICLES_ERROR,
            payload: { msg: "Could not unpublish articles" },
        });
    }
};

//selects a single article
export const selectArticle = (article) => (dispatch) => {
    dispatch({
        type: SELECT_ARTICLE,
        payload: article,
    });

    if (!article) {
        dispatch({
            type: GET_ARTICLE_PRODUCTS,
            payload: [],
        });
    }
};

// EBOOK routes


export const getEbooks = () => async (dispatch) => {
    try {
        const response = await axios.get(`${baseUrl}/api/articles/ebook`);

        dispatch({
            type: GET_EBOOKS,
            payload: response.data,
        });
    } catch (err) {
        dispatch({
            type: GET_EBOOKS_ERROR,
            payload: { msg: "Could not fetch all published ebooks" },
        });
    }
}






// Featured Recent Articles calls
export const getAllFeaturedRecentArticles = () => async (dispatch) => {
    try {
        const response = await axios.get(`${baseUrl}/api/articles/all-featured-recent-articles`);

        dispatch({
            type: GET_ALL_FEATURED_RECENT_ARTICLES,
            payload: response.data,
        });
    } catch (err) {
        dispatch({
            type: GET_ALL_FEATURED_RECENT_ARTICLES_ERROR,
            payload: { msg: "Could not fetch all featured recent articles" },
        });
    }
};

export const getFeaturedRecentArticlesByCategoryId = (categoryId) => async (dispatch) => {
    try {
        const response = await axios.get(`${baseUrl}/api/articles/featured-recent-articles/${categoryId}`);

        dispatch({
            type: GET_FEATURED_RECENT_ARTICLES_BY_CATEGORY,
            payload: response.data,
        });
    } catch (err) {
        dispatch({
            type: GET_FEATURED_RECENT_ARTICLES_BY_CATEGORY_ERROR,
            payload: { msg: "Could not fetch all featured recent articles" },
        });
    }
};

export const deleteFeaturedRecentArticles = (categoryId) => async (dispatch) => {
    try {
        const response = await axios.delete(`${baseUrl}/api/articles/delete-featured-recent-articles/${categoryId}`);

        dispatch({
            type: DELETE_FEATURED_RECENT_ARTICLES,
            payload: response.data,
        });
        dispatch(getAllFeaturedRecentArticles())
        dispatch(setAlert("Categories recent articles deleted uccessfully!", "success"));
    } catch (err) {
        dispatch({
            type: DELETE_FEATURED_RECENT_ARTICLES_ERROR,
            payload: { msg: "Could not delete featured recent articles" },
        });
    }
}

export const addFeaturedRecentArticle = (articleId, categoryId) => async (dispatch) => {
    try {
        const response = await axios.post(`${baseUrl}/api/articles/feature-recent-article/${articleId}/${categoryId}`, {

        });

        dispatch({
            type: ADD_FEATURED_RECENT_ARTICLE,
            payload: response.data,
        });
        dispatch(getAllFeaturedRecentArticles())
        dispatch(setAlert("Featured Recent Article added successfully!", "success"));
    } catch (err) {
        dispatch(setAlert("Failed to add Featured Recent Article", "danger"));
        dispatch({
            type: ADD_FEATURED_RECENT_ARTICLE_ERROR,
            payload: { msg: "Could not add Featured Recent Article" },
        });
    }
}


export const getAllUrlTitles = () => async (dispatch) => {
    try {
        const response = await axios.get(`${baseUrl}/api/articles/all-url-titles`)
        dispatch({
            type: GET_ALL_URL_TITLES,
            payload: response.data,
        });
    } catch (err) {
        console.error('err', err)
    }
}
